export const TOGGLE_FILTER_MODE = 'TOGGLE_FILTER_MODE'

export function filterModeActiveReducer (state = false, action) {
    switch (action.type){
        case TOGGLE_FILTER_MODE:
            return !state
        default: return state
    }
}